import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError, tap, switchMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityPersonasJuridicaLoadRequest,
  entityPersonasJuridicaLoadFailure,
  entityPersonasJuridicaLoadSuccess,
  entityPersonasJuridicaAddFailure,
  entityPersonasJuridicaAddRequest,
  entityPersonasJuridicaAddSuccess,
  entityPersonasJuridicaChangeSuccess,
  entityPersonasJuridicaChangeRequest,
  entityPersonasJuridicaChangeFailure
} from './entity-personas-juridica.actions';
import { NotificationService } from '../../../core/core.module';
import { PersonasJuridicaService } from './entity-personas-juridica.service';

@Injectable()
export class PersonasJuridicaEffects {
  // load
  loadRequestPersonasJuridica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasJuridicaLoadRequest),
      mergeMap(() =>
        this.personasJuridicaService.getPersonasJuridica().pipe(
          map((items) => {
            const personasJuridicas = items.map((item) => {
              return {
                ...item,
                certificado_notarial: `${
                  'https://' +
                  environment.hostBackend +
                  item.certificado_notarial
                }` as any
              };
            });
            return entityPersonasJuridicaLoadSuccess({
              items: personasJuridicas
            });
          }),
          catchError((error) =>
            of(entityPersonasJuridicaLoadFailure({ error }))
          )
        )
      )
    )
  );

  // add
  addRequestPersonasJuridica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasJuridicaAddRequest),
      switchMap((action) =>
        this.personasJuridicaService.addRPEPersonaJuridica(action.item).pipe(
          map((item) => {
            return entityPersonasJuridicaAddSuccess({
              item: item
            });
          }),
          catchError((error) => {
            return of(entityPersonasJuridicaAddFailure({ error: error.error }));
          })
        )
      )
    )
  );

  addFailurePersonasJuridica = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasJuridicaAddFailure),
        tap((error) => {
          this.notificationService.error(error.error.errors[0].detail);
          return;
        })
      ),
    { dispatch: false }
  );

  addSuccessPersonasJuridica = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasJuridicaAddSuccess),
        tap(() => {
          this.notificationService.success('Empresa registrada con éxito');
          return;
        })
      ),
    { dispatch: false }
  );

  // change
  entityPersonasJuridicaChangeRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasJuridicaChangeRequest),
      switchMap((action) =>
        this.personasJuridicaService.changeRPEPersonaJuridica(action.item).pipe(
          map((item) =>
            entityPersonasJuridicaChangeSuccess({
              item: {
                persona: item.persona_juridica,
                rol: item.rol,
                entidadProductiva: item.entidad_productiva
              }
            })
          ),
          catchError((error) => {
            return of(
              entityPersonasJuridicaChangeFailure({ error: error.error })
            );
          })
        )
      )
    )
  );

  entityPersonasJuridicaChangeSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasJuridicaChangeSuccess),
        tap(() => {
          this.notificationService.success('Empresa modificada con éxito');
          return;
        })
      ),
    { dispatch: false }
  );

  // delete

  constructor(
    private actions$: Actions,
    private personasJuridicaService: PersonasJuridicaService,
    private router: Router,
    private readonly notificationService: NotificationService
  ) {
    this.personasJuridicaService.url = environment.apiUrl;
  }
}
